var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMooshir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 58,
    viewBox: "0 0 64 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6158 56.9428L60.7157 56.9133H60.8386L61.1977 56.8592L61.4732 56.7755L61.7339 56.6575L61.97 56.4952L62.1815 56.2984L62.3635 56.0721L62.5062 55.8213L62.6095 55.5507L62.6882 55.1965V54.8325V54.5374L62.6242 54.1685L62.4963 53.7258L42.963 1.70733L42.8794 1.50565L42.6875 1.14164L42.4908 0.866177L42.3038 0.669417L42.0726 0.492333L41.8119 0.389034L41.4824 0.339844H41.4184L41.1134 0.393953L40.8281 0.526766L40.6019 0.698931L40.3707 0.954719L40.1493 1.30889L39.9673 1.71716L31.4525 24.6495L22.8689 1.80079L22.7508 1.53024L22.5934 1.23018L22.3966 0.954719L22.2097 0.757959L21.9834 0.595632L21.7129 0.492333L21.3833 0.443143L21.098 0.492333L20.8176 0.600551L20.5766 0.762878L20.3356 0.984233L20.1093 1.33348L19.8929 1.82538L0.546442 53.7651L0.438224 54.1094L0.364439 54.4784L0.339844 54.8522V54.9162L0.374277 55.2753L0.4579 55.6245L0.571037 55.8901L0.718607 56.1361L0.90061 56.3574L1.12196 56.5493L1.363 56.7018L1.62862 56.8198L1.97787 56.9034L2.33696 56.933L18.4024 56.9034H18.4565L18.8205 56.869L19.1845 56.7805L19.6125 56.6231L20.0355 56.4017L20.3602 56.1803L20.6701 55.9295L21.0144 55.5851L21.2702 55.2753L21.4965 54.9506L21.6932 54.6063L21.8802 54.1832L31.482 28.5306L41.143 54.2472L41.2315 54.4636L41.4086 54.8129L41.6201 55.1474L41.8611 55.472L42.1366 55.7672L42.4268 56.0426L42.7416 56.2886L43.1401 56.5394L43.5483 56.7313L43.9074 56.8493L44.2665 56.928L44.6305 56.9526L44.6158 56.9428ZM20.6258 53.7159L20.5668 53.8635L20.37 54.2373L20.1388 54.5571L19.8683 54.8522L19.5682 55.1031L19.2534 55.3097L18.9878 55.4327L18.6926 55.5261L18.4368 55.5606L2.35663 55.5851H2.31728H2.12544L1.96803 55.4966L1.8303 55.3687L1.73192 55.1523L1.69749 54.867L1.72208 54.5866L1.82046 54.2275L21.1521 2.29269L21.2653 2.03198L21.3784 1.84998V1.87949L21.5752 2.28285L30.7294 26.563L20.6258 53.7159ZM61.3601 54.867V55.0932L61.2961 55.2605L61.1879 55.4081L61.0206 55.5114L60.7599 55.5606L44.6256 55.5851H44.5813L44.2862 55.5409L43.9419 55.4228L43.632 55.2556L43.327 55.0342L43.0368 54.7637L42.7466 54.4144L42.54 54.0898L42.3825 53.7454L32.1756 26.563L41.2561 2.19923L41.3692 1.93852L41.4774 1.76144V1.79587L41.6791 2.19431L61.2125 54.1832V54.2275L61.2961 54.5423V54.8178L61.3601 54.867Z",
    fill: "url(#paint0_linear_1_1802)",
    stroke: "url(#paint1_linear_1_1802)",
    strokeWidth: 0.678822,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1802",
    x1: 0.339844,
    y1: 28.6438,
    x2: 62.7128,
    y2: 28.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FCEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1EC4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#13C0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#06C6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#03C7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#038EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1802",
    x1: 0.000432661,
    y1: 28.6438,
    x2: 63.0522,
    y2: 28.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FCEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1EC4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#13C0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#06C6EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#03C7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#038EE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.0518,
    height: 57.2818,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMooshir);
export default __webpack_public_path__ + "static/media/Mooshir.f3f2c3a6649ed125d70aed461b7a17c9.svg";
export { ForwardRef as ReactComponent };